import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import acnt from 'accounting';
import { map, reduce, concat } from 'lodash';

// Components
import { AddToCartButtons } from '../../../../jsxctl/utilctl';
import { PrepaidCardQtySelectionPriceRow } from '../../molecules/buytickets';

// Types
import { PlaceToGoEnum } from '../../organisms/buytickets/types';

// Utils
import { up } from 'ts-util';
import { analyseAddToCartErrorMessage } from '../../../logic';

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;

interface PrepaidCardQtySelectionProps {
    eventDateId: number;
    priceId: number;
    suggestedAmounts: number[];
    onNewCardAdded?: (placeToGo: typeof PlaceToGoEnum) => void;
    onContentChange?: () => void;
}

export const PrepaidCardQtySelection = createClass<PrepaidCardQtySelectionProps>({
    displayName: "PrepaidCardQtySelection",

    propTypes: {
        eventDateId: PropTypes.number.isRequired,
        priceId: PropTypes.number.isRequired,
        suggestedAmounts: PropTypes.arrayOf(PropTypes.number).isRequired,
        onNewCardAdded: PropTypes.func,
        onContentChange: PropTypes.func
    },

    getInitialState: function () {
        return {
            request: {
                // "40": { amount: 40, qty: 2 }
            }
        };
    },

    componentDidMount: function() {
        this.raiseContentChanged();
    },

    componentDidUpdate: function () {
        this.raiseContentChanged();
    },

    componentWillUnmount(){
        if (this.prepaidCardRequest != null) this.prepaidCardRequest.abort();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    handlePriceRowChange(key, newAmount, newQty) {
        let req = this.state.request;
        if(req[key] == undefined)
            req = up(req, { [key]: { $set: {} } }); // TODO: Change the amount key for the real amount here

        this.setState({
            request: up(req, {
                [key]: {
                    amount: { $set: newAmount },
                    qty: { $set: newQty }
                }
            } )
        });
    },

    getRowQty(amountKey) {
        const rowReq = this.state.request[amountKey.toString()];
        return rowReq != null ? rowReq.qty : 0;
    },

    getRowAmount(amountKey) {
        const rowReq = this.state.request[amountKey.toString()];
        return rowReq != null ? rowReq.amount : 0;
    },

    handleAddPrepaidCardsToCart(placeToGo) {
        this.setState({ addingCard: true });

        this.prepaidCardRequest = tsapp.mvcapi.postCtl("buyticket/addprepaidcardstocart",
                                                        {
                                                            eventDateID: this.props.eventDateId,
                                                            eventPriceID: this.props.priceId,
                                                            ticketQuantitiesPerAmount: map(this.state.request, (r) => ({
                                                                qty: r.qty,
                                                                desiredAmount: r.amount
                                                            }))
                                                        }
        )
                                        .success(function() {
                                            if(this.props.onNewCardAdded != null)
                                                this.props.onNewCardAdded(placeToGo);
                                        }.bind(this))

                                        .notSuccess(function(data) {
                                            this.setState({
                                                addingCard: false,
                                                errorMessage: analyseAddToCartErrorMessage(data)
                                            });
                                        }.bind(this));
    },

    render() {
        const totalAmount = reduce(this.state.request, (acc, p) => acc + (p.amount * p.qty), 0);
        const productSelected = totalAmount > 0; // Tells if we have at least one valid card entered.

        const qtyRows = concat(
            //<PrepaidCardQtySelectionPriceRow key="HEADER" id="HEADER" />
            //,
            map(this.props.suggestedAmounts, function(amount) {
                const key = amount.toString();
                return <PrepaidCardQtySelectionPriceRow
                            key={key}
                            id={key}
                            amount={amount}
                            qty={this.getRowQty(key)}
                            onChange={this.handlePriceRowChange}
                />;
            }.bind(this)),
            <PrepaidCardQtySelectionPriceRow key="CUSTOM" id="CUSTOM" amount={this.getRowAmount("CUSTOM")} qty={this.getRowQty("CUSTOM")} onChange={this.handlePriceRowChange} />
        );

        let totalRow;
        if(productSelected)
            totalRow =
                <p className="text-right lead">
                    <span>{tr("Total") + tr(":")}</span><span>{acnt.formatMoney(totalAmount)}</span>
                </p>;

        let errorMessage = null;
        if(this.state.errorMessage != null)
            errorMessage = <div className="alert alert-danger">{this.state.errorMessage}</div>;


        return (
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
                    <h4>{tr("Quels montants désirez-vous?")}</h4>

                    <div className="list-group">
                        {qtyRows}
                    </div>

                    {totalRow}

                    {errorMessage}
                </div>
                <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
                    <AddToCartButtons
                        onAddToCart={this.handleAddPrepaidCardsToCart}
                        disabled={!productSelected}
                        processing={this.state.addingCard}
                    />
                </div>
            </div>
        );
    }
});
